// prettier-ignore
const layouts = {
  15: {
    '9/19':{
      size: 100/3, // For drag and match the reference axis is 'x'
      layout:[[1, 1, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 5]],
      fontSize: 4.5,
    },
    '9/16':{
      size: 100/3.8,
      layout:[[1, 1, 1, 1],
              [1, 0, 0, 1],
              [1, 0, 0, 1],
              [1, 0, 0, 1],
              [1, 0, 0, 1],
              [1, 1, 1, 0]],
      textColumns: 1,
      textRegion: [[1, 1], [2, 4]],
      fontSize:4,
    },
    '2/3': {
      size: 100/4,
      layout: [[1, 1, 1, 1],
               [1, 0, 0, 1],
               [1, 0, 0, 1],
               [1, 0, 0, 1],
               [1, 0, 0, 1],
               [1, 1, 1, 0]],
      textColumns: 2,
      textRegion: [[1, 1], [2, 4]],
      fontSize: 3.5,
    },
    '3/4': {
      size: 100/4,
      layout: [[1, 1,  1, 1],
               [1, 0,  0, 1],
               [1, 0,  0, 1],
               [1, 0,  0, 1],
               [1, 0,  0, 1],
               [1, 1,  1, 0]],
      textColumns: 2,
      textRegion: [[1, 1], [2, 4]],
      fontSize: 2.7,
    },
    '1/1': {
      size: 100/5,
      layout: [[1, 1, 1, 1, 1],
               [1, 0, 0, 0, 1],
               [1, 0, 0, 0, 1],
               [1, 0, 0, 0, 1],
               [1, 1, 1, 1, 0]],
      textColumns: 2,
      textRegion: [[1, 1], [3, 3]],
      fontSize: 2.5,
    },
    '4/3': {
      size: 100/5.5,
      layout: [[1, 1, 1, 1, 1],
               [1, 0, 0, 0, 1],
               [1, 0, 0, 0, 1],
               [1, 0, 0, 0, 1],
               [1, 1, 1, 1, 0]],
      textColumns: 3,
      textRegion: [[1, 1], [3, 3]],
      fontSize: 2.5,
    },
    '3/2': {
      size: 100/6.5,
      layout: [[1, 1, 1, 1, 1, 1],
               [1, 0, 0, 0, 0, 1],
               [1, 0, 0, 0, 0, 1],
               [1, 1, 1, 1, 1, 0]],
      textColumns: 3,
      textRegion: [[1, 1], [4, 2]],
      fontSize: 2.5,
    },
    '16/9':{
      size: 100/7,
      layout: [[1, 1, 1, 1, 1, 1],
               [1, 0, 0, 0, 0, 1],
               [1, 0, 0, 0, 0, 1],
               [1, 1, 1, 1, 1, 0]],
      textColumns: 3,
      textRegion: [[1, 1], [4, 2]],
      fontSize: 2.3,
    },
    '19/9':{
      size: 100/8,
      layout: [[1, 1, 1, 1, 1, 1, 1],
               [1, 0, 0, 0, 0, 0, 1],
               [1, 1, 1, 1, 1, 1, 0]],
      textColumns: 5,
      textRegion: [[1, 1], [5, 1]],
      fontSize: 2.2,
    },
  },

  
  14: {
    '9/19':{
      size: 100/3.7, 
      layout:[[1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 5]],
      fontSize: 4.2,
    },
    '9/16':{
      size: 100/3.8,
      layout:[[1, 1, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 1, 1]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 4]],
      fontSize:3.7,
    },
    '2/3': {
      size: 100/3.8,
      layout:[[1, 1, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 1, 1]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 4]],
      fontSize:3.2,
    },
    '3/4': {
      size: 100/4.2,
      layout: [[1, 1, 1, 1],
               [1, 0, 0, 1],
               [1, 0, 0, 1],
               [1, 0, 0, 1],
               [1, 1, 1, 1]],
      textColumns: 2,
      textRegion: [[1, 1], [2, 3]],
      fontSize: 2.8,
    },
    '1/1': {
      size: 100/5,
      layout: [[1, 1, 1, 1],
               [1, 0, 0, 1],
               [1, 0, 0, 1],
               [1, 0, 0, 1],
               [1, 1, 1, 1]],
      textColumns: 2,
      textRegion: [[1, 1], [2, 3]],
      fontSize: 2.6,
    },
    '4/3': {
      size: 100/5.5, 
      layout: [[1, 1, 1, 1, 1],
               [1, 0, 0, 0, 1],
               [1, 0, 0, 0, 1],
               [1, 1, 1, 1, 1]],
      textColumns: 3,
      textRegion: [[1, 1], [3, 2]],
      fontSize: 2.4,
    },
    '3/2': {
      size: 100/5.6,
      layout: [[1, 1, 1, 1, 1],
               [1, 0, 0, 0, 1],
               [1, 0, 0, 0, 1],
               [1, 1, 1, 1, 1]],
      textColumns: 3,
      textRegion: [[1, 1], [3, 2]],
      fontSize: 2.3,
    },
    '16/9':{
      size: 100/6.3,
      layout: [[1, 1, 1, 1, 1, 1],
               [1, 0, 0, 0, 0, 1],
               [1, 1, 1, 1, 1, 1]],
      textColumns: 4,
      textRegion: [[1, 1], [4, 1]],
      fontSize: 1.8,
    },
    '19/9':{
      size: 100/6.8,
      layout: [[1, 1, 1, 1, 1, 1],
               [1, 0, 0, 0, 0, 1],
               [1, 1, 1, 1, 1, 1]],
      textColumns: 4,
      textRegion: [[1, 1], [4, 1]],
      fontSize: 1.5,
    },
  },


  13: {
    '9/19':{
      size: 100/3.5, 
      layout:[[1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 1, 1]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 5]],
      fontSize: 4.5,
    },
    '9/16':{
      size: 100/3.8,
      layout:[[1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 1, 1]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 4]],
      fontSize:4,
    },
    '2/3': {
      size: 100/4,
      layout: [[1, 1, 1, 1],
               [1, 0, 0, 1],
               [1, 0, 0, 1],
               [1, 0, 0, 1],
               [1, 1, 1, 0]],
      textColumns: 2,
      textRegion: [[1, 1], [2, 3]],
      fontSize: 3.5,
    },
    '3/4': {
      size: 100/4.2,
      layout: [[1, 1, 1, 1],
               [1, 0, 0, 1],
               [1, 0, 0, 1],
               [1, 0, 0, 1],
               [1, 1, 1, 0]],
      textColumns: 2,
      textRegion: [[1, 1], [2, 3]],
      fontSize: 3.4,
    },
    '1/1': {
      size: 100/5,
      layout: [[1, 1, 1, 1, 1],
               [0, 0, 0, 0, 0],
               [1, 1, 1, 1, 1],
               [0, 1, 1, 1, 0]],
      textColumns: 4,
      textRegion: [[0, 1], [4, 1]],
      fontSize: 3,
    },
    '4/3': {
      size: 100/5, 
      layout: [[1, 1, 0, 1, 1],
               [1, 0, 0, 0, 1],
               [1, 0, 0, 0, 1],
               [1, 1, 1, 1, 1]],
      textColumns: 2,
      textRegion: [[1, 1], [3, 2]],
      fontSize: 3,
    },
    '3/2': {
      size: 100/6,
      layout: [[1, 1, 1, 1, 1, 1],
               [1, 0, 0, 0, 0, 0],
               [0, 0, 0, 0, 0, 0],
               [1, 1, 1, 1, 1, 1]],
      textColumns: 3,
      textRegion: [[1, 1], [4, 2]],
      fontSize: 2.8,
    },
    '16/9':{
      size: 100/7.1,
      layout: [[1, 1, 1, 0, 1, 1, 1],
               [0, 0, 0, 0, 0, 0, 0],
               [1, 1, 1, 1, 1, 1, 1]],
      textColumns: 4,
      textRegion: [[0, 1], [6, 1]],
      fontSize: 2.7,
    },
    '19/9':{
      size: 100/7.1,
      layout: [[1, 1, 1, 0, 1, 1, 1],
               [0, 0, 0, 0, 0, 0, 0],
               [1, 1, 1, 1, 1, 1, 1]],
      textColumns: 4,
      textRegion: [[0, 1], [6, 1]],
      fontSize: 2.7,
    },
  },


  12:  {
    '9/19':{
      size: 100/3.5,  
      layout:[[1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 5]],
      fontSize: 4.5,
    },
    '9/16':{
      size: 100/3.8,
      layout:[[1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 4]],
      fontSize:4,
    },
    '2/3': {
      size: 100/4,
      layout: [[1, 1, 1],
               [1, 0, 1],
               [1, 0, 1],
               [1, 0, 1],
               [1, 1, 1]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 3]],
      fontSize: 3,
    },
    '3/4': {
      size: 100/4.4,
      layout: [[1, 1, 1],
               [1, 0, 1],
               [1, 0, 1],
               [1, 0, 1],
               [1, 1, 1]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 3]],
      fontSize: 3.2,
    },
    '1/1': {
      size: 100/4.5,
      layout: [[1, 1, 1, 1],
               [1, 0, 0, 1],
               [1, 0, 0, 1],
               [1, 1, 1, 1]],
      textColumns: 2,
      textRegion: [[1, 1], [2, 2]],
      fontSize: 2.8,
    },
    '4/3': {
      size: 100/5.7, 
      layout: [[1, 1, 1, 1],
               [1, 0, 0, 1],
               [1, 0, 0, 1],
               [1, 1, 1, 1]],
      textColumns: 3,
      textRegion: [[1, 1], [2, 2]],
      fontSize: 2.4,
    },
    '3/2': {
      size: 100/6,
      layout: [[1, 1, 1, 1],
               [1, 0, 0, 1],
               [1, 0, 0, 1],
               [1, 1, 1, 1]],
      textColumns: 3,
      textRegion: [[1, 1], [2, 2]],
      fontSize: 2.3,
    },
    '16/9':{
      size: 100/5.8,
      layout: [[1, 1, 1, 1, 1],
               [1, 0, 0, 0, 1],
               [1, 1, 1, 1, 1]],
      textColumns: 4,
      textRegion: [[1, 1], [3, 1]],
      fontSize: 2.1,
    },
    '19/9':{
      size: 100/7.5,
      layout: [[1, 1, 1, 1, 1],
               [1, 0, 0, 0, 1],
               [1, 1, 1, 1, 1]],
      textColumns: 4,
      textRegion: [[1, 1], [3, 1]],
      fontSize: 1.8,
    },
  },


  11:  {
    '9/19':{
      size: 100/3.5,  
      layout:[[1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 5]],
      fontSize: 4.5,
    },
    '9/16':{
      size: 100/3.8,
      layout:[[1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 4]],
      fontSize:4,
    },
    '2/3': {
      size: 100/4,
      layout: [[1, 1, 1],
               [1, 0, 1],
               [1, 0, 1],
               [1, 0, 1],
               [1, 1, 1]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 3]],
      fontSize: 3,
    },
    '3/4': {
      size: 100/4,
      layout: [[1, 1, 1],
               [1, 0, 1],
               [1, 0, 1],
               [1, 0, 1],
               [1, 1, 1]],
      textColumns: 2,
      textRegion: [[1, 1], [1, 3]],
      fontSize: 3.2,
    },
    '1/1': {
      size: 100/4.5,
      layout: [[1, 1, 1, 1],
               [1, 0, 0, 1],
               [1, 0, 0, 1],
               [1, 1, 1, 1]],
      textColumns: 2,
      textRegion: [[1, 1], [2, 2]],
      fontSize: 2.8,
    },
    '4/3': {
      size: 100/4.9, 
      layout: [[1, 1, 1, 1],
               [1, 0, 0, 1],
               [1, 0, 0, 1],
               [1, 1, 1, 1]],
      textColumns: 3,
      textRegion: [[1, 1], [2, 2]],
      fontSize: 2.6,
    },
    '3/2': {
      size: 100/4.9,
      layout: [[1, 1, 1, 1],
               [1, 0, 0, 1],
               [1, 0, 0, 1],
               [1, 1, 1, 1]],
      textColumns: 3,
      textRegion: [[1, 1], [2, 2]],
      fontSize: 2.3,
    },
    '16/9':{
      size: 100/5.8,
      layout: [[1, 1, 1, 1, 1],
               [1, 0, 0, 0, 1],
               [1, 1, 1, 1, 1]],
      textColumns: 4,
      textRegion: [[1, 1], [3, 1]],
      fontSize: 2.1,
    },
    '19/9':{
      size: 100/10,
      layout: [[1, 1, 1, 1, 1],
               [1, 0, 0, 0, 1],
               [1, 1, 1, 1, 1]],
      textColumns: 4,
      textRegion: [[1, 1], [3, 1]],
      fontSize: 1.8,
    },
  },


  10:  {
    '9/19':{
      size: 100/3, 
      layout:[[1, 1],
              [1, 1],
              [0, 1],
              [0, 1],
              [0, 1],
              [0, 1],
              [1, 1]],
      textColumns: 1,
      textRegion: [[0, 2], [0, 5]],
      fontSize: 4.5,
    },
    '9/16':{
      size: 100/3.7,
      layout:[[1, 0, 1],
              [0, 0, 0],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1],
              [1, 0, 1]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 4]],
      fontSize:4,
    },
    '2/3': {
      size: 100/4,
      layout: [[1, 0, 1],
               [1, 0, 1],
               [1, 0, 1],
               [1, 0, 1],
               [1, 0, 1]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 3]],
      fontSize: 3.5,
    },
    '3/4': {
      size: 100/4.2,
      layout: [[1, 0, 1],
               [1, 0, 1],
               [1, 0, 1],
               [1, 0, 1],
               [1, 0, 1]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 3]],
      fontSize: 3.4,
    },
    '1/1': {
      size: 100/5,
      layout: [[1, 1, 1, 1],
               [1, 0, 0, 1],
               [1, 0, 0, 1],
               [0, 1, 1, 0]],
      textColumns: 2,
      textRegion: [[1, 1], [2, 2]],
      fontSize: 2.4,
    },
    '4/3': {
      size: 100/5.5, 
      layout: [[1, 1, 1, 1, 1],
               [1, 0, 0, 0, 1],
               [0, 1, 1, 1, 0]],
      textColumns: 3,
      textRegion: [[1, 1], [3, 1]],
      fontSize: 2.3,
    },
    '3/2': {
      size: 100/6,
      layout: [[1, 1, 1, 1, 1],
               [1, 0, 0, 0, 1],
               [1, 0, 1, 0, 1]],
      textColumns: 3,
      textRegion: [[1, 1], [3, 1]],
      fontSize: 2.1,
    },
    '16/9':{
      size: 100/7.1,
      layout: [[1, 1, 1, 1, 1],
               [1, 0, 0, 0, 1],
               [1, 0, 1, 0, 1]],
      textColumns: 3,
      textRegion: [[1, 1], [3, 1]],
      fontSize: 1.8,
    },
    '19/9':{
      size: 100/8.1,
      layout: [[1, 1, 1, 1, 1],
               [1, 0, 0, 0, 1],
               [1, 0, 1, 0, 1]],
      textColumns: 4,
      textRegion: [[1, 1], [3, 1]],
      fontSize: 1.6,
    },
  },


  9:  {
    '9/19':{
      size: 100/4, 
      layout:[[1, 1],
              [0, 0],
              [0, 0],
              [0, 1],
              [1, 1],
              [1, 1],
              [1, 1]],
      textColumns: 2,
      textRegion: [[0, 1], [1, 2]],
      fontSize: 4.5,
    },
    '9/16':{
      size: 100/3.7,
      layout: [[1, 0, 1],
               [1, 0, 1],
               [1, 0, 1],
               [1, 0, 1],
               [1, 0, 0]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 3]],
      fontSize:4,
    },
    '2/3': {
      size: 100/4.6,
      layout: [[1, 0, 1],
               [1, 0, 1],
               [1, 0, 1],
               [1, 0, 1],
               [1, 0, 0]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 3]],
      fontSize: 3.5,
    },
    '3/4': {
      size: 100/5.2,
      layout: [[1, 0, 1],
               [1, 0, 1],
               [1, 0, 1],
               [1, 0, 1],
               [1, 0, 0]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 3]],
      fontSize: 3.4,
    },
    '1/1': {
      size: 100/6,
      layout: [[0, 1, 1, 0],
               [1, 0, 0, 1],
               [1, 0, 0, 1],
               [1, 1, 0, 1]],
      textColumns: 2,
      textRegion: [[1, 1], [2, 2]],
      fontSize: 2.8,
    },
    '4/3': {
      size: 100/6.3, 
      layout: [[1, 1, 1, 1],
               [1, 0, 0, 1],
               [1, 1, 0, 1]],
      textColumns: 2,
      textRegion: [[1, 1], [2, 1]],
      fontSize: 3,
    },
    '3/2': {
      size: 100/6.8,
      layout: [[1, 1, 0, 1, 1],
               [1, 0, 0, 0, 1],
               [1, 0, 1, 0, 1]],
      textColumns: 3,
      textRegion: [[1, 1], [3, 1]],
      fontSize: 2.8,
    },
    '16/9':{
      size: 100/8,
      layout: [[1, 1, 0, 1, 1],
               [1, 0, 0, 0, 1],
               [1, 0, 1, 0, 1]],
      textColumns: 4,
      textRegion: [[1, 1], [4, 1]],
      fontSize: 2.3,
    },
    '19/9':{
      size: 100/9,
      layout: [[1, 1, 0, 1, 1],
               [1, 0, 0, 0, 1],
               [1, 0, 1, 0, 1]],
      textColumns: 4,
      textRegion: [[1, 1], [4, 1]],
      fontSize: 2,
    },
  },


  8:  {
    '9/19':{
      size: 100/3, 
      layout:[[1, 1],
              [1, 1],
              [0, 0],
              [0, 0],
              [1, 1],
              [1, 1]],
      textColumns: 2,
      textRegion: [[0, 2], [1, 3]],
      fontSize: 4.5,
    },
    '9/16':{
      size: 100/3.4, 
      layout:[[1, 1],
              [1, 1],
              [0, 0],
              [0, 0],
              [1, 1],
              [1, 1]],
      textColumns: 2,
      textRegion: [[0, 2], [1, 3]],
      fontSize: 4.1,
    },
    '2/3': {
      size: 100/3.5,
      layout: [[1, 1, 1],
               [1, 0, 1],
               [1, 0, 1],
               [0, 1, 0]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 2]],
      fontSize: 3.7,
    },
    '3/4': {
      size: 100/3.4,
      layout: [[1, 1, 1],
               [1, 0, 1],
               [1, 0, 1],
               [0, 1, 0]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 2]],
      fontSize: 3,
    },
    '1/1': {
      size: 100/4,
      layout: [[1, 1, 1],
               [1, 0, 1],
               [1, 1, 1]],
      textColumns: 2,
      textRegion: [[1, 1], [1, 1]],
      fontSize:2.5,
    },
    '4/3': {
      size: 100/4.3, 
      layout: [[1, 1, 1, 1],
               [1, 0, 0, 1],
               [0, 1, 1, 0]],
      textColumns: 3,
      textRegion: [[1, 1], [2, 1]],
      fontSize: 2.4,
    },
    '3/2': {
      size: 100/5,
      layout: [[1, 1, 1, 1],
               [1, 0, 0, 1],
               [0, 1, 1, 0]],
      textColumns: 3,
      textRegion: [[1, 1], [2, 1]],
      fontSize: 2.1,
    },
    '16/9':{
      size: 100/6,
      layout: [[1, 0, 1, 0, 1],
               [1, 0, 0, 0, 1],
               [1, 0, 1, 0, 1]],
      textColumns: 3,
      textRegion: [[1, 1], [3, 1]],
      fontSize: 2.1,
    },
    '19/9':{
      size: 100/8,
      layout: [[1, 0, 1, 0, 1],
               [1, 0, 0, 0, 1],
               [1, 0, 1, 0, 1]],
      textColumns: 3,
      textRegion: [[1, 1], [3, 1]],
      fontSize: 1.6,
    },
  },

  7:  {
    '9/19':{
      size: 100/3, 
      layout:[[1, 1],
              [1, 1],
              [0, 0],
              [0, 0],
              [1, 1],
              [1, 1]],
      textColumns: 2,
      textRegion: [[0, 2], [1, 3]],
      fontSize: 4.5,
    },
    '9/16':{
      size: 100/3.4, 
      layout:[[1, 1],
              [1, 1],
              [0, 0],
              [0, 0],
              [1, 1],
              [1, 1]],
      textColumns: 2,
      textRegion: [[0, 2], [1, 3]],
      fontSize: 4.1,
    },
    '2/3': {
      size: 100/3.5,
      layout: [[1, 1, 1],
               [1, 0, 1],
               [1, 0, 1],
               [0, 1, 0]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 2]],
      fontSize: 3.7,
    },
    '3/4': {
      size: 100/3.4,
      layout: [[1, 1, 1],
               [1, 0, 1],
               [1, 0, 1],
               [0, 1, 0]],
      textColumns: 1,
      textRegion: [[1, 1], [1, 2]],
      fontSize: 3,
    },
    '1/1': {
      size: 100/4,
      layout: [[1, 1, 1],
               [1, 0, 1],
               [1, 1, 1]],
      textColumns: 2,
      textRegion: [[1, 1], [1, 1]],
      fontSize:2.5,
    },
    '4/3': {
      size: 100/4.3, 
      layout: [[1, 1, 1, 1],
               [1, 0, 0, 1],
               [0, 1, 1, 0]],
      textColumns: 3,
      textRegion: [[1, 1], [2, 1]],
      fontSize: 2.4,
    },
    '3/2': {
      size: 100/5,
      layout: [[1, 1, 1, 1],
               [1, 0, 0, 1],
               [0, 1, 1, 0]],
      textColumns: 3,
      textRegion: [[1, 1], [2, 1]],
      fontSize: 2.1,
    },
    '16/9':{
      size: 100/6,
      layout: [[1, 0, 1, 0, 1],
               [1, 0, 0, 0, 1],
               [1, 0, 1, 0, 1]],
      textColumns: 3,
      textRegion: [[1, 1], [3, 1]],
      fontSize: 2.1,
    },
    '19/9':{
      size: 100/8,
      layout: [[1, 0, 1, 0, 1],
               [1, 0, 0, 0, 1],
               [1, 0, 1, 0, 1]],
      textColumns: 3,
      textRegion: [[1, 1], [3, 1]],
      fontSize: 1.6,
    },
  },

  6:  {
    '9/19':{
      size: 100/2.2, 
      layout:[[1, 1],
              [0, 0],
              [0, 0],
              [0, 0],
              [1, 1],
              [1, 1]],
      textColumns: 1,
      textRegion: [[0, 1], [1, 3]],
      fontSize: 6,
    },
    '9/16':{
      size: 100/3, 
      layout:[[0, 0],
              [1, 1],
              [0, 0],
              [0, 0],
              [1, 1],
              [1, 1],
              [0, 0]],
      textColumns: 2,
      textRegion: [[0, 2], [1, 3]],
      fontSize:6,
    },
    '2/3': {
      size: 100/3.2,
      layout:[[1, 1],
              [0, 0],
              [0, 0],
              [1, 1],
              [1, 1]],
      textColumns: 2,
      textRegion: [[0, 1], [1, 2]],
      fontSize: 5,
    },
    '3/4': {
      size: 100/3.5,
      layout:[[1, 1],
              [0, 0],
              [0, 0],
              [1, 1],
              [1, 1]],
      textColumns: 2,
      textRegion: [[0, 1], [1, 2]],
      fontSize: 4.5,
    },
    '1/1': {
      size: 100/3.5,
      layout: [[1, 1, 1 ],
               [0, 0, 0 ],
               [0, 0, 0 ],
               [1, 1, 1 ]],
      textColumns: 1,
      textRegion: [[0, 1], [2, 2]],
      fontSize:3.5,
    },
    '4/3': {
      size: 100/3.5,
      layout: [[1, 1, 1 ],
               [0, 0, 0 ],
               [1, 1, 1 ]],
      textColumns: 3,
      textRegion: [[0, 1], [2, 1]],
      fontSize: 3,
    },
    '3/2': {
      size: 100/3.5,
      layout: [[1, 1, 1 ],
               [0, 0, 0 ],
               [1, 1, 1 ]],
      textColumns: 3,
      textRegion: [[0, 1], [2, 1]],
      fontSize: 2.8,
    },
    '16/9':{
      size: 100/4.5,
      layout: [[1, 1, 1, 1],
               [0, 0, 0, 0],
               [1, 0, 0, 1]],
      textColumns: 2,
      textRegion: [[1, 1], [2, 2]],
      fontSize: 2.7,
    },
    '19/9':{
      size: 100/7.1,
      layout: [[1, 0, 0, 1, 1],
               [1, 0, 0, 1, 1]],
      textColumns: 1,
      textRegion: [[1, 0], [2, 1]],
      fontSize: 2.5,
    },
  },

  5:  {
    '9/19':{
      size: 100/2.5, 
      layout:[[0, 0],
              [1, 1],
              [0, 0],
              [0, 0],
              [1, 1],
              [1, 1]],
      textColumns: 1,
      textRegion: [[0, 2], [1, 3]],
      fontSize: 5,
    },
    '9/16':{
      size: 100/3, 
      layout:[[1, 1],
              [0, 0],
              [0, 0],
              [1, 1],
              [1, 0]],
      textColumns: 1,
      textRegion: [[0, 1], [1, 2]],
      fontSize:4.3,
    },
    '2/3': {
      size: 100/3.2,
      layout:[[1, 1],
              [0, 0],
              [0, 0],
              [1, 1],
              [1, 1]],
      textColumns: 1,
      textRegion: [[0, 1], [1, 2]],
      fontSize: 4,
    },
    '3/4': {
      size: 100/3.5,
      layout:[[1, 1],
              [0, 0],
              [0, 0],
              [1, 1],
              [1, 1]],
      textColumns: 1,
      textRegion: [[0, 1], [1, 2]],
      fontSize: 4,
    },
    '1/1': {
      size: 100/3.5,
      layout: [[1, 1, 1 ],
               [0, 0, 0 ],
               [0, 0, 0 ],
               [1, 1, 1 ]],
      textColumns: 2,
      textRegion: [[0, 1], [2, 2]],
      fontSize:3,
    },
    '4/3': {
      size: 100/3.5,
      layout: [[1, 1, 1 ],
               [0, 0, 0 ],
               [1, 1, 1 ]],
      textColumns: 3,
      textRegion: [[0, 1], [2, 1]],
      fontSize: 2.7,
    },
    '3/2': {
      size: 100/4.4,
      layout: [[1, 1, 1 ],
               [0, 0, 0 ],
               [1, 1, 1 ]],
      textColumns: 3,
      textRegion: [[0, 1], [2, 1]],
      fontSize: 2.3,
    },
    '16/9':{
      size: 100/5,
      layout: [[1, 1, 1],
               [1, 0, 0],
               [1, 0, 0]],
      textColumns: 2,
      textRegion: [[1, 1], [2, 2]],
      fontSize: 2.2,
    },
    '19/9':{
      size: 100/5.4,
      layout: [[1, 0, 0, 1, 1],
               [1, 0, 0, 1, 1]],
      textColumns: 1,
      textRegion: [[1, 0], [2, 1]],
      fontSize: 2.0,
    },
  },
  

  25: {
    '9/19':{
      size: 100/5.6, // For drag and match the reference axis is 'x'
      layout:[[1, 1, 1, 1, 1],
              [1, 0, 0, 0, 1],
              [1, 0, 0, 0, 1],
              [1, 0, 0, 0, 1],
              [1, 0, 0, 0, 1],
              [1, 0, 0, 0, 1],
              [1, 0, 0, 0, 1],
              [1, 0, 0, 0, 1],
              [1, 0, 0, 0, 1],
              [1, 1, 1, 1, 0]],
      textColumns: 3,
      textRegion: [[1, 1], [3, 8]],
      fontSize: 10,
    },
    '9/16':{
      size: 100/6.8,
      layout:[[1, 1, 1, 1, 1],
              [1, 0, 0, 0, 1],
              [1, 0, 0, 0, 1],
              [1, 0, 0, 0, 1],
              [1, 0, 0, 0, 1],
              [1, 0, 0, 0, 1],
              [1, 0, 0, 0, 1],
              [1, 0, 0, 0, 1],
              [1, 0, 0, 0, 1],
              [1, 1, 1, 1, 0]],
      textColumns: 3,
      textRegion: [[1, 1], [3, 8]],
      fontSize:8,
    },
    '2/3': {
      size: 100/6.5,
      layout:[[1, 1, 1, 1, 1, 1],
              [1, 0, 0, 0, 0, 1],
              [1, 0, 0, 0, 0, 1],
              [1, 0, 0, 0, 0, 1],
              [1, 0, 0, 0, 0, 1],
              [1, 0, 0, 0, 0, 1],
              [1, 0, 0, 0, 0, 1],
              [1, 0, 0, 0, 0, 1],
              [1, 1, 1, 1, 1, 0]],
      textColumns: 4,
      textRegion: [[1, 1], [4, 7]],
      fontSize: 8,
    },
    '3/4': {
      size: 100/7.8,
      layout:[[1, 1, 1, 1, 1, 1],
              [1, 0, 0, 0, 0, 1],
              [1, 0, 0, 0, 0, 1],
              [1, 0, 0, 0, 0, 1],
              [1, 0, 0, 0, 0, 1],
              [1, 0, 0, 0, 0, 1],
              [1, 0, 0, 0, 1, 1],
              [1, 1, 1, 1, 1, 1]],
      textColumns: 4,
      textRegion: [[1, 1], [4, 6]],
      fontSize: 7,
    },
    '1/1': {
      size: 100/7.6,
      layout:[[1, 1, 1, 1, 1, 1],
              [1, 0, 0, 0, 1, 1],
              [1, 0, 0, 0, 1, 1],
              [1, 0, 0, 0, 1, 1],
              [1, 0, 0, 1, 1, 1],
              [1, 1, 1, 1, 1, 1]],
      textColumns: 4,
      textRegion: [[1, 1], [3, 4]],
      fontSize: 6,
    },
    '4/3': {
      size: 100/8.5, 
      layout:[[1, 1, 1, 1, 1, 1, 1],
              [1, 1, 0, 0, 0, 1, 1],
              [1, 1, 0, 0, 0, 1, 1],
              [1, 1, 0, 0, 0, 1, 1],
              [1, 1, 1, 1, 1, 1, 0]],
      textColumns: 5,
      textRegion: [[2, 1], [4, 3]],
      fontSize: 5,
    },
    '3/2': {
      size: 100/9.4,
      layout:[[1, 1, 1, 1, 1, 1, 1, 1],
              [1, 1, 0, 0, 0, 0, 0, 1],
              [1, 1, 0, 0, 0, 0, 0, 1],
              [1, 1, 0, 0, 0, 0, 0, 1],
              [1, 1, 1, 1, 1, 1, 1, 1]],
      textColumns: 6,
      textRegion: [[2, 1], [7, 3]],
      fontSize: 5,
    },
    '16/9':{
      size: 100/11,
      layout:[[1, 1, 1, 1, 1, 1, 1, 1, 1],
              [1, 0, 0, 0, 0, 0, 0, 0, 1],
              [1, 0, 0, 0, 0, 0, 0, 0, 1],
              [1, 0, 0, 0, 0, 0, 0, 1, 1],
              [1, 1, 1, 1, 1, 1, 1, 1, 1]],
      textColumns: 7,
      textRegion: [[1, 1], [7, 3]],
      fontSize: 4,
    },
    '19/9':{
      size: 100/14,
      layout:[[1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
              [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
              [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
              [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0]],
      textColumns: 9,
      textRegion: [[1, 1], [9, 2]],
      fontSize: 4,
    },
  },
}

export default layouts;
